const state = {
    data: null
}

const getters = {
}

const mutations = {
    setData (state, data) {
        state.data = data ? data : null
    }
}

const actions = {
    async data (context) {
        const response = await axios.get('/api/v1/app/data').catch(error => error.response || null)
        context.commit('setData', response ? response.data.data : null)
        return response
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

